module.exports = __webpack_public_path__ + "img/brief_0.f354e746.jpg";